var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bnr87uy40a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAD01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9b7dh3o81b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAD01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q36qroq1kc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1080FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "canrzfqg8d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1080FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V21H0z",
    transform: "translate(-26 -203) translate(0 170) translate(16) translate(0 31) translate(10 2) translate(3.5 3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bnr87uy40a)",
    fillRule: "nonzero",
    d: "M15.944 6.842l3.614-2.065c-.144-.145-.317-.26-.529-.376L12.244.52C11.658.183 11.072 0 10.504 0c-.576 0-1.162.183-1.748.521l-1.951 1.11 9.14 5.211z",
    transform: "translate(-26 -203) translate(0 170) translate(16) translate(0 31) translate(10 2) translate(3.5 3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9b7dh3o81b)",
    fillRule: "nonzero",
    d: "M10.505 9.94l4.104-2.335-9.102-5.221L1.98 4.4c-.211.116-.384.231-.538.376l9.063 5.163z",
    transform: "translate(-26 -203) translate(0 170) translate(16) translate(0 31) translate(10 2) translate(3.5 3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q36qroq1kc)",
    fillRule: "nonzero",
    d: "M11.158 21c.068-.02.125-.048.193-.087l7.525-4.304c.894-.512 1.374-1.033 1.374-2.432V6.659c0-.29-.02-.521-.077-.733l-9.015 5.172V21z",
    transform: "translate(-26 -203) translate(0 170) translate(16) translate(0 31) translate(10 2) translate(3.5 3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#canrzfqg8d)",
    fillRule: "nonzero",
    d: "M9.842 21v-9.902L.827 5.926c-.058.212-.077.443-.077.733v7.518c0 1.4.49 1.92 1.374 2.432l7.535 4.304c.058.039.115.068.183.087z",
    transform: "translate(-26 -203) translate(0 170) translate(16) translate(0 31) translate(10 2) translate(3.5 3.5)"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCopy);
export default __webpack_public_path__ + "static/media/box-copy.30bc7d0ca2f471031edb7e3d5907a70f.svg";
export { ForwardRef as ReactComponent };